import * as React from "react";
// import { Link } from "gatsby";`

import facebook from "../img/social/facebook.svg";
import instagram from "../img/social/instagram.svg";
// import nationallottery from "../img/digital-black-background.png";
import nationallottery from "../img/digital-white-background.png";

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer has-background-black has-text-white-ter">
        <div className="content has-text-centered has-background-black has-text-white-ter">
          <div className="container has-background-black has-text-white-ter">
          <div style={{ maxWidth: "100vw" }} className="columns">
              <div className="column is-4 address-line-text">
                <p>Telephone: <a className="external-link" href="tel:07930073077">07930 073077</a></p>
                <p>Email: <a className="external-link" href="mailto:brierleyhillbabybank@gmail.com">brierleyhillbabybank@gmail.com</a></p>
              </div>
              <div className="column is-4">
                <img
                  className="national-lottery-funding-image"
                  src={nationallottery}
                  alt="The National Lottery Community Fund"
                />
              </div>
              <div className="column is-4 address-line-text">
                Brierley Hill Babybank<br/>
                8 Darwin House<br/>
                The Innovation Centre<br/>
                Pensnett Trading Estate<br/>
                Kingswinford<br/>
                DY6 7YB
              </div>
            </div>
            <div style={{ maxWidth: "100vw" }} className="columns">
              <div className="column is-4">
                      <a
                        className="navbar-item"
                        href="/admin/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ width: "0em", height: "0em", color: "white", padding: 0 }}
                      >
                        Login
                      </a>
              </div>
              <div className="column is-4 social">
                <a title="facebook" href="https://facebook.com/Brierleyhillbaby" target="_blank" rel="noreferrer">
                  <img
                    src={facebook}
                    alt="Facebook - Brierley Hill Babybank"
                    style={{ width: "1em", height: "1em" }}
                  />
                </a>
                <a title="instagram" href="https://www.instagram.com/brierleyhillbabybank/?igshid=MzRlODBiNWFlZA%3D%3D" target="_blank" rel="noreferrer">
                  <img
                    src={instagram}
                    alt="Instagram - Brierley Hill Babybank"
                    style={{ width: "1em", height: "1em" }}
                  />
                </a>
              </div>
              <div className="column is-4 registered-charity-text">
                Registered charity number: 1186640
              </div>
            </div>
          </div>
        </div>
        <br/>
      </footer>
    );
  }
};

export default Footer;
